import { useSelector } from 'react-redux';

export const useMenuHistory = () => {
    return useSelector(({ menuHistory: { orders } }) => orders);
};

export const useMenuHistoryMenu = () => {
    return useSelector(({ menuHistory: { dishlist } }) => dishlist);
};
